import { render } from "./AdjustmentCategory.vue?vue&type=template&id=06b466a9&ts=true"
import script from "./AdjustmentCategory.vue?vue&type=script&lang=ts"
export * from "./AdjustmentCategory.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__